import { render, staticRenderFns } from "./UsuariosPorUG.vue?vue&type=template&id=7fa361a4&scoped=true"
import script from "./UsuariosPorUG.vue?vue&type=script&lang=ts"
export * from "./UsuariosPorUG.vue?vue&type=script&lang=ts"
import style0 from "./UsuariosPorUG.vue?vue&type=style&index=0&id=7fa361a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa361a4",
  null
  
)

export default component.exports